import ElementPage from "../../../Elements";
import { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import DigitalRamNameTab from "./DigitalRamNameTab";
import MyRamNameTab from "./MyRamNameTab";
import ProductCategoryPage from "../../product-category/CategoryList";
import { t } from "i18next";
import MemberHeader from "./MemberHeader";
import { getMemberTotalSummary } from "../RamNamBookCRUD";
import { toast } from "react-toastify";

const MemberDashboard = () => {
  const [activeTab, setActiveTab] = useState("digital");

  const [loading, setLoading] = useState(false);
  const [memberRamNameData, setMemberRamNameData] = useState({});
  const [memberId, setMemberId] = useState(null);

  useEffect(() => {
    document.body.classList.add("member-dashboard");

    // Load member from storage
    const storedCustomer = localStorage.getItem("customer");
    if (!storedCustomer) {
      toast.error("Member not found. Please login again.");
      return;
    }

    const customerObj = JSON.parse(storedCustomer);
    if (!customerObj?.ramNamBookMemberID) {
      toast.error("Invalid member data");
      return;
    }

    setMemberId(customerObj.ramNamBookMemberID);
    return () => {
      document.body.classList.remove("member-dashboard");
    };
  }, []);

  // ✅ STEP 2: Call API when memberId is available
  useEffect(() => {
    setLoading(true);
    if (!memberId) return;
    if (activeTab === "myram") {
      // setMemberRamNameData([]);
      getMemberTotalSummaryData(memberId);
    }
  }, [memberId, activeTab]);

  const getMemberTotalSummaryData = async (memberId) => {
    try {
      const res = await getMemberTotalSummary(memberId);
      if (res.data?.isSuccess) {
        setMemberRamNameData(res.data.data);
        setLoading(false);
      } else {
        toast.error(res.data?.message || "Failed to load summary");
        setLoading(false);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const tabStyle = (key) => ({
    borderRadius: "50px",
    padding: "10px 20px",
    fontWeight: 600,
    transition: "all 0.3s ease",
    background:
      activeTab === key
        ? "linear-gradient(135deg, #ff4f00, #ff7a18)"
        : "transparent",
    color: activeTab === key ? "#fff" : "#ff4f00",
    boxShadow: activeTab === key ? "0 4px 10px rgba(255, 79, 0, 0.35)" : "none",
  });

  return (
    <>
      <MemberHeader />
      <div className="container md:hidden mt-3 py-2">
        {" "}
        {/* <div
        className="md:hidden container-fluid py-3"
        style={{
          marginTop: "calc(var(--header-height) * -1)",
          minHeight: "100vh",
        }}
      > */}
        <div className="border-0 mt-1">
          <div className="card-body py-2">
            <Tabs
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              //   variant="pills"
              className="justify-content-center gap-2 mb-4"
            >
              <Tab
                eventKey="digital"
                title={
                  <span style={tabStyle("digital")}>🙏 {t("digitalRAM")}</span>
                }
              >
                <DigitalRamNameTab />
              </Tab>

              <Tab
                eventKey="purchase"
                title={
                  <span style={tabStyle("purchase")}>
                    📚 {t("purchaseBook")}
                  </span>
                }
              >
                <ProductCategoryPage />
              </Tab>

              <Tab
                eventKey="myram"
                title={
                  <span style={tabStyle("myram")}>🏦 {t("myRAMName")}</span>
                }
                // onClick={getMemberTotalSummaryData(memberId)}
              >
                <MyRamNameTab
                  memberRamNameData={memberRamNameData}
                  loading={loading}
                />
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
      {/* ----------------for mobile displays----------------- */}

      <div className="container hidden md:block py-1">
        <div className="border-0 mt-0">
          <div className="card-body py-4">
            <Tabs
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              //   variant="pills"
              className="justify-content-center gap-2 mb-4"
            >
              <Tab
                eventKey="digital"
                title={
                  <span style={tabStyle("digital")}>🙏 {t("digitalRAM")}</span>
                }
              >
                <DigitalRamNameTab />
              </Tab>

              <Tab
                eventKey="purchase"
                title={
                  <span style={tabStyle("purchase")}>
                    📚 {t("purchaseBook")}
                  </span>
                }
              >
                <ProductCategoryPage />
              </Tab>

              <Tab
                eventKey="myram"
                title={
                  <span style={tabStyle("myram")}>🏦 {t("myRAMName")}</span>
                }
                // onClick={getMemberTotalSummaryData(memberId)}
              >
                <MyRamNameTab
                  memberRamNameData={memberRamNameData}
                  loading={loading}
                />
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
      {/* <ElementPage /> */}
    </>
  );
};

export default MemberDashboard;
